// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { taraxaTestnet as _taraxaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the taraxaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 842
 * Chain Name: Taraxa Testnet
 * Default Block Explorer: https://explorer.testnet.taraxa.io
 * Default RPC URL: https://rpc.testnet.taraxa.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { taraxaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: taraxaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const taraxaTestnet = createCommon({
	..._taraxaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
